export const DATE_DELIMITER = "/";
export const AMEX_NAMES = ["american express", "ae", "amex"];
